

import React from 'react';
import styled from 'styled-components'

import Emmanuel from '../images/emmanuel.svg';
import Aisling from '../images/aisling.svg';
import Logo from '../images/logo-pink.svg';
import Microphone from '../images/microphone.svg';

const HeadContainer = styled.div`
    height: 270px;
    position: relative;
    
    @media (min-width: 768px) {
        height: 400px;
    }
    @media (min-width: 1150px) {
        height: 580px;
    }
`
const Image = styled.img`
    top: 50%;
    left: 50%;
    width: 100%;
    max-width: 120px;
    position: absolute;
    transform: translate(-50%, -70%);
    
    @media (min-width: 768px) {
        max-width: 200px;
    }
    @media (min-width: 1150px) {
        max-width: 300px;
    }

    &.emmanuel {
        z-index: 1;
        transform: translate(-91%, -70%);
    }
    &.aisling {
        transform: translate(-9%,-70%);
    }
    &.logo {
        top: auto;
        bottom: 0;
        max-width: 270px;
        transform: translate(-50%,-40%);

        @media (min-width: 768px) {
            max-width: 400px;
            transform: translate(-50%,-30%);
        }
        @media (min-width: 1150px) {
            max-width: 580px;
        }
    }
`
const MicrophoneImg = styled.img`
    max-width: 40px;
`
const ContentContainer = styled.div`
    padding: 30px;
 
    @media (min-width: 768px) {
        padding: 50px 30px;
        max-width: 500px;
        margin: 0 auto;
    }
    @media (min-width: 1150px) {
        padding: 50px;
    }
`
const Content = styled.h1`
    margin: 0 auto;
    padding: 15px 0;
    font-size: 19px;
    max-width: 600px;
    line-height: 29px;

    @media (min-width: 1150px) {
        padding: 15px;
        font-size: 30px;
        line-height: 40px;
    }
`

const Head = () => {
    return (
        <section>
            <HeadContainer>
                <Image className="emmanuel" src={Emmanuel} alt="Emmanuel - Podcast cohost"/>
                <Image className="aisling" src={Aisling} alt="Aisling - Podcast cohost"/>
                <Image className="logo" src={Logo} alt="Dermatology the podcast logo - text"/>
            </HeadContainer>
            <ContentContainer>
                <MicrophoneImg src={Microphone} alt="Icon"/>
                <Content>Welcome to Dermatology UK The Podcast, the podcast where we talk about all things skin!</Content>
            </ContentContainer>
        </section>
    );
};

export default Head;
